<template>
  <!--
          作者：kmdshop
          时间：2019-10-24
          描述：统计-销售统计
      -->
    <div v-loading="loading" style="min-height: 400px;">
     
       <!-- 筛选条件区域 -->
  <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
  <div class="grid grid-cols-4 gap-4">

  
  <div class="relative"  v-if="isuse == 1">
  <div class="border rounded px-3 py-2 cursor-pointer" @click="toggleSupplierDropdown">
  {{selectedSupplier ? selectedSupplier.name : '选择供应商'}}
  <i class="fas fa-chevron-down absolute right-2 top-3"></i>
  </div>
  <div v-if="showSupplierDropdown" class="absolute z-10 w-full bg-white border rounded mt-1 shadow-lg">
  <div v-for="item in supply" :key="item.supply_id" 
  class="px-3 py-2 hover:bg-gray-100 cursor-pointer"
  @click="selectSupplier(item)">
  {{item.name}}
  </div>
  </div>
  </div>
  
  <!-- <div class="flex space-x-2">
  <input type="date" v-model="form.startDate" class="border rounded px-3 py-2">
  <span class="py-2">至</span>
  <input type="date" v-model="form.endDate" class="border rounded px-3 py-2">
  </div> -->
  </div>
  
  <div class="flex justify-end mt-4 space-x-4">
  <button class="btn-primary !rounded-button whitespace-nowrap px-4 py-2" @click="handleSearch">查询</button>
  <button class="btn-default !rounded-button whitespace-nowrap px-4 py-2" @click="handleReset">重置</button>
  </div>
  </div>
     
     
      <!--汇总-->
      <Total v-if="!loading"></Total>
      <!--交易统计-->
      <Transaction v-if="!loading"></Transaction>
      <!--商品统计-->
      <Product v-if="!loading"></Product>
    </div>
</template>

<script>
  import StatisticsApi from '@/api/statistics.js';
  import Total from './part/Total.vue'
  import Transaction from './part/Transaction.vue'
  import Product from './part/Product.vue'
  import Warehouse_managementApi from '@/api/warehouse_management.js';
  export default{
    components:{
      Total,
      Transaction,
      Product
    },
    data(){
      return{
        /*是否正在加载*/
        loading:true,
        /*数据对象*/
        dataModel:{},
        supply:[],
        form:{

        },
        isuse:0,
        selectedSupplier: null,
        showSupplierDropdown:false,
      }
    },
    provide: function () {
      return {
        dataModel: this.dataModel
      }
    },
    created() {
          /*获取数据*/
      var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
      self.getSupplys()
  
    self.getData();
    },
    methods:{
      selectSupplier(item) {
        this.selectedSupplier = item;
        this.form.supply_id = item.supply_id
        this.showSupplierDropdown = false;
   
      },
      toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
  
        this.showWarehouseDropdown = false;
  
      },
      getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
                self.form_w.supply_id = self.supplyArr[0].supply_id
                self.form_w.t_supply_id = self.supplyArr[0].supply_id
                self.form_w.product_sku_id = self.productArr[0].product_sku_id

                self.form_o.supply_id = self.supplyArr[0].supply_id
                self.form_o.t_supply_id = self.supplyArr[0].supply_id
                self.form_o.product_sku_id = self.productArr[0].product_sku_id
                })
                .catch(error => {
                });
        },
        handleSearch() {
          this.loading = true;
        // 实现查询逻辑
        this.getData();
      },
      handleReset() {
        this.form.startDate = '';
        this.form.endDate = '';
        this.form.supply_id = ''
        this.getData();

      },
      /*获取数据*/
      getData() {
        let self = this;
        StatisticsApi.getOrderTotal(self.form, true)
          .then(res => {
            Object.assign(self.dataModel, res.data);
            self.$forceUpdate()
            self.loading = false;
          })
          .catch(error => {});
      }

    }
  }
</script>

<style>
.btn-primary {
    @apply bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50;
  }
  
  .btn-default {
    @apply bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50;
  }
  
  .max-h-40::-webkit-scrollbar {
    width: 6px;
  }
  
  .max-h-40::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  .max-h-40::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  
  .max-h-40::-webkit-scrollbar-thumb:hover {
    background: #666;
  }
</style>



// WEBPACK FOOTER //
// src/views/statistics/sales/index.vue